import Component from '../inherited/Component'

export default class AnimationsFullWidth extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    let stickyButton = document.querySelector('[data-animations-sticky-cta] .button-wrapper')
    let isIntersecting = false

    const observer = new window.IntersectionObserver(([entry]) => {
      isIntersecting = entry.isIntersecting
    }, {
      root: null,
      threshold: 0
    })

    observer.observe(this._elem);

    window.addEventListener('scroll', () => {
      let windowHeight = window.innerHeight
      let elemTop = this._elem.getBoundingClientRect().top
      let elemHeight = this._elem.getBoundingClientRect().height
      let offset = 200
      let hideStart = elemTop + window.scrollY + (elemHeight * 0.25)
      let hideEnd = hideStart + elemHeight
      let scrolled = window.scrollY + windowHeight

      if (isIntersecting) {
        if ((elemTop + offset) < 0 || elemTop > windowHeight / 2) {
          this._elem.classList.remove('active')
        } else if (elemTop < windowHeight / 2) {
          this._elem.classList.add('active')
        }

        if (stickyButton) {
          if (scrolled >= hideStart && scrolled <= hideEnd) {
            stickyButton.classList.add('hidden')
          } else {
            stickyButton.classList.remove('hidden')
          }
        }
      }

      
    }, { passive: true })
  }
}